import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
declare var jQuery: any;
declare var $: any;

@Component({
	selector: 'app-membership',
	templateUrl: './membership.component.html',
	styleUrls: ['./membership.component.scss']
})
export class MembershipComponent implements OnInit {

	membershipList: any = "";
	faqList: any = "";
	faqrequest: any = {};
	bannerList: any = "";
	bannerrequest: any = {};

	constructor(private allpagesService: AllPageService,) { }

	ngOnInit() {
		this.loadBanner();
		this.loadFaq();
		this.allpagesService.getMembership().then((data) => {
			this.membershipList = data;
			console.log(this.membershipList);
		});


	}

	loadFaq() {
		this.faqrequest = {

		};
		let request = Object.assign({}, this.faqrequest);
		this.allpagesService.getMembershipFaq(request).then((data: any) => {
			this.faqList = data;
			setTimeout(() => {
				jQuery(".faq-title > a.faq-add").on("click", function () {
					if (jQuery(this).hasClass("active")) {
						jQuery(this).removeClass("active");
						jQuery(this)
							.siblings(".faq-content")
							.slideUp(400);
					} else {

						jQuery(".faq-title > a.faq-add").removeClass("active");
						jQuery(this).addClass("active");
						jQuery(".faq-content").slideUp(400);
						jQuery(this)
							.siblings(".faq-content")
							.slideDown(400);
					}

				});

			}, 1000);
			//console.log(this.faqList);
		});
	}

	loadBanner() {
		this.bannerrequest = {
			title: 'Membership'
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.bannerList = data.data[0];
			//console.log(this.bannerList);
		});
	}

}
